'use client';
import { useCallback } from 'react';

export const useNormalizedPixels = () => {
  const { width, height } = window.screen;

  const normalizePixels = useCallback(
    (size: number, based: 'width' | 'height' = 'width') => {
      const widthBaseScale = width / 1920;
      const heightBaseScale = height / 1080;

      return based === 'height' ? size * heightBaseScale : size * widthBaseScale;
    },
    [width, height]
  );

  return { normalizePixels };
};
